/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListRecordTagsParams,
  SetTagsIn,
  TagNamesOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listAllTagsResponse200 = {
  data: TagNamesOut
  status: 200
}

export type listAllTagsResponseSuccess = (listAllTagsResponse200) & {
  headers: Headers;
};
;

export type listAllTagsResponse = (listAllTagsResponseSuccess)

export const getListAllTagsUrl = () => {




  return `/api/tags`
}

/**
 * @summary List All Tags
 */
export const listAllTags = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listAllTagsResponse> => {

  return apiFetch<listAllTagsResponse>(getListAllTagsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAllTagsQueryKey = () => {
    return [
    `/api/tags`
    ] as const;
    }


export const getListAllTagsQueryOptions = <TData = Awaited<ReturnType<typeof listAllTags>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllTags>>> = ({ signal }) => listAllTags({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAllTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listAllTags>>>
export type ListAllTagsQueryError = unknown


export function useListAllTags<TData = Awaited<ReturnType<typeof listAllTags>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllTags>>,
          TError,
          Awaited<ReturnType<typeof listAllTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllTags<TData = Awaited<ReturnType<typeof listAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllTags>>,
          TError,
          Awaited<ReturnType<typeof listAllTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAllTags<TData = Awaited<ReturnType<typeof listAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List All Tags
 */

export function useListAllTags<TData = Awaited<ReturnType<typeof listAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAllTagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listRecordTagsResponse200 = {
  data: TagNamesOut
  status: 200
}

export type listRecordTagsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listRecordTagsResponseSuccess = (listRecordTagsResponse200) & {
  headers: Headers;
};
export type listRecordTagsResponseError = (listRecordTagsResponse422) & {
  headers: Headers;
};

export type listRecordTagsResponse = (listRecordTagsResponseSuccess | listRecordTagsResponseError)

export const getListRecordTagsUrl = (params: ListRecordTagsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/tags/on-record?${stringifiedParams}` : `/api/tags/on-record`
}

/**
 * @summary List Record Tags
 */
export const listRecordTags = async (params: ListRecordTagsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listRecordTagsResponse> => {

  return apiFetch<listRecordTagsResponse>(getListRecordTagsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecordTagsQueryKey = (params?: ListRecordTagsParams,) => {
    return [
    `/api/tags/on-record`, ...(params ? [params] : [])
    ] as const;
    }


export const getListRecordTagsQueryOptions = <TData = Awaited<ReturnType<typeof listRecordTags>>, TError = HTTPValidationError>(params: ListRecordTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecordTagsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecordTags>>> = ({ signal }) => listRecordTags(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecordTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecordTagsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecordTags>>>
export type ListRecordTagsQueryError = HTTPValidationError


export function useListRecordTags<TData = Awaited<ReturnType<typeof listRecordTags>>, TError = HTTPValidationError>(
 params: ListRecordTagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecordTags>>,
          TError,
          Awaited<ReturnType<typeof listRecordTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecordTags<TData = Awaited<ReturnType<typeof listRecordTags>>, TError = HTTPValidationError>(
 params: ListRecordTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecordTags>>,
          TError,
          Awaited<ReturnType<typeof listRecordTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecordTags<TData = Awaited<ReturnType<typeof listRecordTags>>, TError = HTTPValidationError>(
 params: ListRecordTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Record Tags
 */

export function useListRecordTags<TData = Awaited<ReturnType<typeof listRecordTags>>, TError = HTTPValidationError>(
 params: ListRecordTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecordTags>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecordTagsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setRecordTagsResponse200 = {
  data: TagNamesOut
  status: 200
}

export type setRecordTagsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setRecordTagsResponseSuccess = (setRecordTagsResponse200) & {
  headers: Headers;
};
export type setRecordTagsResponseError = (setRecordTagsResponse422) & {
  headers: Headers;
};

export type setRecordTagsResponse = (setRecordTagsResponseSuccess | setRecordTagsResponseError)

export const getSetRecordTagsUrl = () => {




  return `/api/tags/on-record`
}

/**
 * @summary Set Record Tags
 */
export const setRecordTags = async (setTagsIn: SetTagsIn, options?: Parameters<typeof apiFetch>[1]): Promise<setRecordTagsResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setRecordTagsResponse>(getSetRecordTagsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setTagsIn)
  }
);}





export const getSetRecordTagsMutationKey = () => ['setRecordTags'] as const;

export const getSetRecordTagsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRecordTags>>, TError,SetRecordTagsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setRecordTags>>, TError,SetRecordTagsMutationVariables, TContext> => {

const mutationKey = getSetRecordTagsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setRecordTags>>, SetRecordTagsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setRecordTags(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetRecordTagsMutationResult = NonNullable<Awaited<ReturnType<typeof setRecordTags>>>
    export type SetRecordTagsMutationBody = SetTagsIn
    export type SetRecordTagsMutationError = HTTPValidationError
    export type SetRecordTagsMutationVariables = {data: SetTagsIn}

    /**
 * @summary Set Record Tags
 */
export const useSetRecordTags = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setRecordTags>>, TError,SetRecordTagsMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setRecordTags>>,
        TError,
        SetRecordTagsMutationVariables,
        TContext
      > => {
      return useMutation(getSetRecordTagsMutationOptions(options), queryClient);
    }
